import { Link } from "react-router-dom";
import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { useSite } from "@/lib/site";
import { Logo } from "./Navbar";

export default function Footer() {
  const { content, packages } = useSite();
  const phone = content.phone || "+1 323 786 1615";
  return (
    <footer className="relative bg-[#090D16] text-slate-300 overflow-hidden grain" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10 relative">
        <p className="font-display font-extrabold tracking-tight text-white text-5xl sm:text-7xl lg:text-8xl leading-none">
          Think. Build. <span className="text-blue-500">Grow.</span>
        </p>
        <div className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-4">
            <Logo light />
            <p className="text-sm text-slate-400 max-w-xs">Digital marketing, Google & Meta Ads and web development for ambitious businesses.</p>
          </div>
          <div>
            <p className="overline !text-slate-500 mb-4">Services</p>
            <ul className="space-y-2.5 text-sm">
              {packages.map((p) => (
                <li key={p.id}><Link to={`/services/${p.id}`} className="hover:text-white transition-colors" data-testid={`footer-service-${p.id}`}>{p.name}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <p className="overline !text-slate-500 mb-4">Studio</p>
            <ul className="space-y-2.5 text-sm">
              {[["Pricing", "/pricing"], ["Work", "/work"], ["About", "/about"], ["Contact", "/contact"]].map(([l, to]) => (
                <li key={to}><Link to={to} className="hover:text-white transition-colors" data-testid={`footer-link-${l.toLowerCase()}`}>{l}</Link></li>
              ))}
            </ul>
          </div>
          <div className="space-y-3">
            <p className="overline !text-slate-500 mb-4">Talk to us</p>
            <a href={`tel:${phone.replace(/[^+\d]/g, "")}`} data-testid="footer-phone" className="flex items-center gap-2 text-white text-lg font-display font-semibold hover:text-blue-400 transition-colors">
              <Phone className="w-4 h-4" /> {phone}
            </a>
            <a href={`mailto:${content.email}`} data-testid="footer-email" className="flex items-center gap-2 text-sm hover:text-white transition-colors">
              <Mail className="w-4 h-4" /> {content.email}
            </a>
            <Link to="/contact" className="inline-flex items-center gap-1 text-sm text-blue-400 hover:text-blue-300" data-testid="footer-cta">Start a conversation <ArrowUpRight className="w-4 h-4" /></Link>
          </div>
        </div>
        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Click & Grow Digital. All rights reserved.</p>
          <Link to="/admin" className="hover:text-slate-300" data-testid="footer-admin-link">Owner sign in</Link>
        </div>
      </div>
    </footer>
  );
}
